import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import SetupEntityForm from 'components/organisms/forms/SetupEntityForm'

import {
  useDELETE_schoolSetupAccommodationMutation,
  useGET_schoolSetupAccommodationByIdQuery,
  usePATCH_schoolSetupAccommodationMutation,
  usePOST_schoolSetupAccommodationMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupModificationMutation,
  useGET_schoolSetupModificationByIdQuery,
  usePATCH_schoolSetupModificationMutation,
  usePOST_schoolSetupModificationMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupAssessmentStrategyMutation,
  useGET_schoolSetupAssessmentStrategyByIdQuery,
  usePATCH_schoolSetupAssessmentStrategyMutation,
  usePOST_schoolSetupAssessmentStrategyMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupConcernReasonMutation,
  useGET_schoolSetupConcernReasonByIdQuery,
  usePATCH_schoolSetupConcernReasonMutation,
  usePOST_schoolSetupConcernReasonMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupLessonPlanOptionMutation,
  useGET_schoolSetupLessonPlanOptionByIdQuery,
  usePATCH_schoolSetupLessonPlanOptionMutation,
  usePOST_schoolSetupLessonPlanOptionMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupInstructionalStrategyMutation,
  useGET_schoolSetupInstructionalStrategyByIdQuery,
  usePATCH_schoolSetupInstructionalStrategyMutation,
  usePOST_schoolSetupInstructionalStrategyMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupInterventionStrategyMutation,
  useGET_schoolSetupInterventionStrategyByIdQuery,
  usePATCH_schoolSetupInterventionStrategyMutation,
  usePOST_schoolSetupInterventionStrategyMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupInterventionTypeMutation,
  useGET_schoolSetupInterventionTypeByIdQuery,
  usePATCH_schoolSetupInterventionTypeMutation,
  usePOST_schoolSetupInterventionTypeMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupPlopCategoryMutation,
  useGET_schoolSetupPlopCategoryByIdQuery,
  usePATCH_schoolSetupPlopCategoryMutation,
  usePOST_schoolSetupPlopCategoryMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupProblemAreaMutation,
  useGET_schoolSetupProblemAreaByIdQuery,
  usePATCH_schoolSetupProblemAreaMutation,
  usePOST_schoolSetupProblemAreaMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupProgressMonitoringToolMutation,
  useGET_schoolSetupProgressMonitoringToolByIdQuery,
  usePATCH_schoolSetupProgressMonitoringToolMutation,
  usePOST_schoolSetupProgressMonitoringToolMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupMonitoringMethodMutation,
  useGET_schoolSetupMonitoringMethodByIdQuery,
  usePATCH_schoolSetupMonitoringMethodMutation,
  usePOST_schoolSetupMonitoringMethodMutation,
} from 'redux/api/setupApi'
import {
  useDELETE_schoolSetupMeetingCategoryMutation,
  useGET_schoolSetupMeetingCategoryByIdQuery,
  usePATCH_schoolSetupMeetingCategoryMutation,
  usePOST_schoolSetupMeetingCategoryMutation,
} from 'redux/api/setupApi'
import { crudActionsMap } from 'utils/helpers'
import MeetingCategoryForm from 'components/organisms/forms/MeetingCategoryForm'
import PlopCategoryForm from 'components/organisms/forms/PlopCategoryForm'

const SetupEntityCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id
  const type = params?.type

  const action = crudActionsMap[params['*']?.split('/')?.[3]]
  const viewOnly = action === 'view' || action === 'delete'

  const map = {
    'accommodations': {
      component: null,
      title: t('common.accommodations'),
      getEntityQuery: useGET_schoolSetupAccommodationByIdQuery,
      createEntityMutation: usePOST_schoolSetupAccommodationMutation,
      editEntityMutation: usePATCH_schoolSetupAccommodationMutation,
      deleteEntityMutation: useDELETE_schoolSetupAccommodationMutation,
    },
    'modifications': {
      component: null,
      title: t('common.modifications'),
      getEntityQuery: useGET_schoolSetupModificationByIdQuery,
      createEntityMutation: usePOST_schoolSetupModificationMutation,
      editEntityMutation: usePATCH_schoolSetupModificationMutation,
      deleteEntityMutation: useDELETE_schoolSetupModificationMutation,
    },
    'assessment-strategies': {
      component: null,
      title: t('common.assessment-strategies'),
      getEntityQuery: useGET_schoolSetupAssessmentStrategyByIdQuery,
      createEntityMutation: usePOST_schoolSetupAssessmentStrategyMutation,
      editEntityMutation: usePATCH_schoolSetupAssessmentStrategyMutation,
      deleteEntityMutation: useDELETE_schoolSetupAssessmentStrategyMutation,
    },
    'concern-reasons': {
      component: null,
      title: t('common.concern-reasons'),
      getEntityQuery: useGET_schoolSetupConcernReasonByIdQuery,
      createEntityMutation: usePOST_schoolSetupConcernReasonMutation,
      editEntityMutation: usePATCH_schoolSetupConcernReasonMutation,
      deleteEntityMutation: useDELETE_schoolSetupConcernReasonMutation,
    },
    'lesson-plan-options': {
      component: null,
      title: t('common.lesson-plan-options'),
      getEntityQuery: useGET_schoolSetupLessonPlanOptionByIdQuery,
      createEntityMutation: usePOST_schoolSetupLessonPlanOptionMutation,
      editEntityMutation: usePATCH_schoolSetupLessonPlanOptionMutation,
      deleteEntityMutation: useDELETE_schoolSetupLessonPlanOptionMutation,
    },
    'instructional-strategies': {
      component: null,
      title: t('common.instructional-strategies'),
      getEntityQuery: useGET_schoolSetupInstructionalStrategyByIdQuery,
      createEntityMutation: usePOST_schoolSetupInstructionalStrategyMutation,
      editEntityMutation: usePATCH_schoolSetupInstructionalStrategyMutation,
      deleteEntityMutation: useDELETE_schoolSetupInstructionalStrategyMutation,
    },
    'intervention-strategies': {
      component: null,
      title: t('common.intervention-strategies'),
      getEntityQuery: useGET_schoolSetupInterventionStrategyByIdQuery,
      createEntityMutation: usePOST_schoolSetupInterventionStrategyMutation,
      editEntityMutation: usePATCH_schoolSetupInterventionStrategyMutation,
      deleteEntityMutation: useDELETE_schoolSetupInterventionStrategyMutation,
    },
    'intervention-types': {
      component: null,
      title: t('common.intervention-types'),
      getEntityQuery: useGET_schoolSetupInterventionTypeByIdQuery,
      createEntityMutation: usePOST_schoolSetupInterventionTypeMutation,
      editEntityMutation: usePATCH_schoolSetupInterventionTypeMutation,
      deleteEntityMutation: useDELETE_schoolSetupInterventionTypeMutation,
    },
    'problem-areas': {
      component: null,
      title: t('common.problem-areas'),
      getEntityQuery: useGET_schoolSetupProblemAreaByIdQuery,
      createEntityMutation: usePOST_schoolSetupProblemAreaMutation,
      editEntityMutation: usePATCH_schoolSetupProblemAreaMutation,
      deleteEntityMutation: useDELETE_schoolSetupProblemAreaMutation,
    },
    'progress-monitoring-tools': {
      component: null,
      title: t('common.progress-monitoring-tools'),
      getEntityQuery: useGET_schoolSetupProgressMonitoringToolByIdQuery,
      createEntityMutation: usePOST_schoolSetupProgressMonitoringToolMutation,
      editEntityMutation: usePATCH_schoolSetupProgressMonitoringToolMutation,
      deleteEntityMutation: useDELETE_schoolSetupProgressMonitoringToolMutation,
    },
    'monitoring-methods': {
      component: null,
      title: t('common.monitoring-methods'),
      getEntityQuery: useGET_schoolSetupMonitoringMethodByIdQuery,
      createEntityMutation: usePOST_schoolSetupMonitoringMethodMutation,
      editEntityMutation: usePATCH_schoolSetupMonitoringMethodMutation,
      deleteEntityMutation: useDELETE_schoolSetupMonitoringMethodMutation,
    },
    'plop-categories': {
      component: <PlopCategoryForm action={action} id={id} viewOnly={viewOnly} />,
      title: t('common.plop-categories'),
      getEntityQuery: useGET_schoolSetupPlopCategoryByIdQuery,
      createEntityMutation: usePOST_schoolSetupPlopCategoryMutation,
      editEntityMutation: usePATCH_schoolSetupPlopCategoryMutation,
      deleteEntityMutation: useDELETE_schoolSetupPlopCategoryMutation,
    },
    'meeting-categories': {
      component: <MeetingCategoryForm action={action} id={id} viewOnly={viewOnly} />,
      title: t('common.meeting-categories'),
      getEntityQuery: useGET_schoolSetupMeetingCategoryByIdQuery,
      createEntityMutation: usePOST_schoolSetupMeetingCategoryMutation,
      editEntityMutation: usePATCH_schoolSetupMeetingCategoryMutation,
      deleteEntityMutation: useDELETE_schoolSetupMeetingCategoryMutation,
    },
  }


  return (
      map[type] &&  <>
          <PageHeading title={`${map[type].title} / ${t('common.' + action)}`} />
          <PageBody>
            {!map[type].component && <SetupEntityForm 
              action={action} 
              id={id} 
              viewOnly={viewOnly}   
              entityType={type}
              entityName={map[type].title}
              getEntityQuery={map[type].getEntityQuery}
              createEntityMutation={map[type].createEntityMutation}
              editEntityMutation={map[type].editEntityMutation}
              deleteEntityMutation={map[type].deleteEntityMutation}
              />
            }
            {!!map[type].component && map[type].component}
          </PageBody>  
        </>
   
  )
}
export default SetupEntityCrudPage
